/* eslint-disable max-len */
const STRINGS = {
	smapplyLogoAltText: gettext("SurveyMonkey Apply logo"),
	dontHaveAccount: gettext("Don't have an account?"),
	register: gettext("Register"),
	login: gettext("Log in"),
	emailAddress: gettext("Email address"),
	password: gettext("Password"),
	passwordLabel: gettext("Enter password"),
	enterPassword: gettext("Enter your password"),
	forgotPassword: gettext("Forgot password?"),
	forgotPasswordMessage: gettext(
		"Please check your email inbox. If you have an account, you'll receive an email with instructions on how to reset your password."
	),
	next: gettext("Next"),
	orLoginWith: gettext("Or log in with"),
	or: gettext("or"),
	back: gettext("Back"),
	help: gettext("Help"),
	termsOfUse: gettext("Terms of Use"),
	privacyNotice: gettext("Privacy Notice"),
	enterCode: gettext("Enter code to finish logging in"),
	checkAuthApp: gettext("Check your authenticator app to get the verification code"),
	enterCodeProvided: gettext("Enter the code provided"),
	rememberDevice: gettext("Remember this device for 14 days"),
	submit: gettext("Submit"),
	tryAnotherMethod: gettext("Try another method"),
	couldNotVerifyCode: gettext("We couldn't verify the code. Please try again later."),
	mfaCodeExpired: gettext("Code expired. Refresh the page and try again."),
	too_many_attempts: gettext("Too many login attempts. Wait a few minutes, then try again."),
	invalid_credentials: gettext("Invalid email or password."),
	account_locked: gettext(
		"Invalid email or password. Your account has been temporarily locked due to too many failed login attempts. Please try again later."
	),
	site_inactive: gettext(
		"Only site administrators can log in at this time. Please contact the sites administrator for assistance."
	),
	user_inactive: gettext(
		"Your account is inactive. Please contact technical support for assistance."
	),
	site_user_inactive: gettext(
		"Your account is inactive. Please contact the site administrator for assistance."
	),
	site_user_doesnt_exist: gettext(
		"Your account is not associated with this site. Registration is required before logging in."
	),
	unknownError: gettext(
		"An unknown error has occurred. Please contact technical support for assistance."
	),
	cookie_not_enabled: gettext(
		"Cookies are not enabled in your browser. Please enable cookies to continue."
	),
	invalid_email: gettext("Please enter a valid email address."),
	success: gettext("Success!"),
	rateLimitError: gettext(
		"You can't send another request right now. Please wait a few minutes and try again."
	),
	requestSent: gettext("Request sent!"),
	staff_login_restricted: gettext("Login failed, staff login is restricted to marketplace."),
	error: gettext("Error"),
	important: gettext("Important"),
	saveBtn: gettext("Save"),
	cancel: gettext("Cancel"),
	cancelBtn: gettext("Cancel"),
	ok: gettext("Ok"),
	credentialsTableHeader: gettext("Credentials"),
	name: gettext("Name"),
	currentPassword: gettext("Current Password"),
	newPassword: gettext("New Password"),
	email: gettext("Email"),
	preferredLanguage: gettext("Preferred Language"),
	language: gettext("Language"),
	languageNote: gettext(
		"Note: Only sites with this language enabled will use your preferred language."
	),
	timezone: gettext("Timezone"),
	disconnectBtn: gettext("Disconnect"),
	change: gettext("Change"),
	clear: gettext("Clear"),
	unsavedChanges: gettext("Unsaved Changes"),
	firstName: gettext("First Name"),
	lastName: gettext("Last Name"),
	googleSSO: gettext("Google Social Sign On"),
	pleaseSelect: gettext("Please Select..."),
	resendRequest: gettext("Resend Request"),
	emailAddressChangePending: gettext("An email address change has been requested"),
	currentlyEditing: gettext("You must finish editing before you can save changes"),
	newPasswordPlaceholder: gettext("Create your password"),
	applicantNotificationsLabel: gettext("Applicant Notifications"),
	reviewerNotificationsLabel: gettext("Reviewer Notifications"),
	recommenderNotificationsLabel: gettext("Recommender Notifications"),
	generalNotifications: gettext("General"),
	recaptchaVerificationFailed: gettext("Recaptcha verification failed. Please try again."),
	optional: gettext("Optional"),
	instructions: gettext("Instructions"),
	troubleScanning: gettext("Trouble scanning?"),
	scanQR: gettext(
		"Scan the QR code with your authenticator app to get a one time code to register this device."
	),
	then: gettext("then"),
	tryQR: gettext("Try a new QR code"),
	setUpMFA: gettext("Set up multi-factor authentication"),
	changeMFADevice: gettext("Change multi-factor authentication device"),
	enterCodeToLogin: gettext("Enter code to finish logging in"),
	checkApp: gettext("Check your authenticator app to get the verification code"),
	mfaChallenge: gettext(
		"To complete your login request, please enter the code from your authenticator app."
	),
	useSecurityKey: gettext(
		"To manually set up multi-factor authentication, enter the security code below into your authenticator app"
	),
	not_authorized: gettext("You are not currently logged in. Please log in to continue."),
	not_authenticated: gettext("You have been logged out. Please log in again to continue."),
	session_expired: gettext("Your session has expired. Please log in again."),
	session_stale_refresh: gettext(
		"Your session may be stale. Please refresh the page and try again."
	),
	rate_limit_exceeded: gettext("Too many failed attempts. Wait a few minutes, then try again."),
	unableToLoadQR: gettext("Unable to load QR code."),
	continue: gettext("Continue"),
	already_enrolled: gettext(
		"You are already enrolled. Please log out and log in again to continue."
	),
	allSet: gettext("You're all set!"),
	mfaDeviceUpdated: gettext("MFA device updated"),
	recoveryCodes: gettext("Recovery Codes"),
	recoveryCodeDescription: gettext(
		"We have generated 10 single use recovery codes that can be used to complete a MFA challenge in the event that you are unable to access your device."
	),
	recoveryCodesDescription: gettext(
		"Store these codes in a safe place. They provide single use access to your account if you lose access to your authenticator app."
	),
	whenYouLoginMFA: gettext(
		"When you log in, you'll be asked to verify your identity using multi-factor authentication."
	),
	learnMoreAboutManagingMFA: gettext("Learn more about managing MFA."),
	keepCodesSafe: gettext("Please keep these codes in a safe location."),
	limitedVisibility: gettext("You will not be able to view or download them again."),
	continueToSite: gettext("Continue to site"),
	mfa: gettext("Multi-Factor Authentication"),
	productName: gettext("SurveyMonkey Apply"),
	invalid_code: gettext("We couldn't verify the code. Please try again."),
	invalid_code_locked_out: gettext("We couldn't verify the code. Please try again later."),
	missing_code: gettext("Missing code. Please enter the code from your authenticator app."),
	rate_limited: gettext("Too many failed attempts. Wait a few minutes, then try again."),
	code_expired: gettext("Code expired. Refresh the page and try again."),
	cancelAndLogout: gettext("Cancel and log out"),
	finish: gettext("Finish"),
	copyFailed: gettext("Copying to clipboard failed, please copy the codes manually"),
	lockedOutTitle: gettext("Your account is locked"),
	lockedOutMessage: gettext(
		"Your account has been temporarily locked due to too many failed login or MFA attempts. Please try again later."
	),
	lockedOutButton: gettext("Return to login"),
	lockedOutSupport: gettext("If you are experiencing issues logging in, please"),
	lockedOutSupportLink: gettext("contact technical support."),
	emailMFAWarning: gettext(
		"We recommend using an authenticator app for multi-factor authentication (MFA) as it provides a more secure and reliable method than Email."
	),
	useAuthenticatorAppInstead: gettext("Use an authenticator app instead"),
	startEmailEnrollment: gettext("Begin Email Enrollment"),
	email_enrollment_started: gettext(
		"We have sent a code to your email address. Please enter the code below to complete the enrollment process. The code expires in 5 minutes."
	),
	checkEmail: gettext("Please check your email for the code"),
	code_already_pending: gettext(
		"A code has already been sent to your email address. Please check your email and enter the code below."
	),
	returnToHomepage: gettext("Return to homepage"),
	errorSendingMFACode: gettext("Error sending email MFA code"),
	errorFetchingSecurityKey: gettext("Error fetching security key"),
	selectMFAMethod: gettext("Select a multi-factor authentication method"),
	selectMFAMethodMessage: gettext(
		"Please select one of your verified multi-factor authentication methods to use to log in."
	),
	totpMethod: gettext("Authenticator App"),
	emailMethod: gettext("Email"),
	enterCodeToContinue: gettext("Enter code to continue"),
	enterOneTimeCodeToContinue: gettext("Enter one-time code to continue"),
	beforeChangingDevice: gettext(
		"Before changing your enrolled device, please retrieve a code from your current device and enter it into the field below. If you do not have access to your current device, you can recover your account using your recovery email address or contact technical support."
	),
	beforeChangingDeviceEmail: gettext(
		"Use the 'Send Code' button below to have a code sent to your email address. Once received, enter the code below to continue. If you do not have access to this email, you can recover your account using your recovery email address or contact technical support."
	),
	whatMethod: gettext(
		"What method would you like to use for your new device? Authenticator app (TOTP) is recommended."
	),
	totpOnly: gettext(
		"Since you are using your email address for multi-factor authentication (MFA), you can only set up an authenticator app (TOTP) as your new device."
	),
	authenticatorAppTOTP: gettext("Authenticator App (TOTP)"),
	setupUsingAuthenticatorApp: gettext("Setup using authenticator app"),
	setupUsingEmail: gettext("Setup using email"),
	email_sent: gettext("We've sent a code to your email address"),
	resendCode: gettext("Resend code"),
	sendCode: gettext("Send code"),
	changeInProgress: gettext(
		"A device change is already in progress. Please complete enrollment of your new device to continue. This change will expire in 5 minutes if not completed."
	),
	no_change_requested: gettext(
		"No device change has been requested. Please start the device change process from your account settings."
	),
	invalid_action: gettext("Something went wrong. Please try again."),

	// Recovery Email Setup
	addRecoveryEmailTitle: gettext("Add recovery email address"),
	recoveryEmailBackupDescription: gettext(
		"Get a backup option to sign in to help keep your account secure in the event that you are unable to access your device."
	),
	addRecoveryEmailPlaceholder: gettext("Add recovery email address"),
	verify: gettext("Verify"),
	resend: gettext("Resend"),
	sending: gettext("Sending..."),
	pleaseWaitBeforeResending: gettext("Please wait before resending"),
	invalidEmailFormat: gettext("Please enter a valid email address"),
	recoveryEmail: gettext("Recovery Email"),
	addRecoveryEmail: gettext("Add recovery email"),
	recoveryEmailDescription: gettext(
		"This email will be used to recover your account if you lose access to your MFA device."
	),
	enterRecoveryEmailAddress: gettext("Enter your recovery email address"),
	recoveryEmailPlaceholder: gettext("Enter email address"),
	wellSendVerificationCode: gettext("We'll send a verification code to verify this email."),
	sendVerificationCode: gettext("Send verification code"),

	// Recovery Email Verification
	verificationCodeTitle: gettext("Verification code"),
	enterOtpDescription: gettext(
		"Enter one-time verification code sent to your recovery email address"
	),
	confirm: gettext("Confirm"),
	verifyRecoveryEmail: gettext("Verify recovery email"),
	enterVerificationCode: gettext("Enter verification code"),
	enterVerificationCodeDescription: gettext(
		"Please enter the verification code that is sent to your email"
	),
	verificationCodeSentTo: gettext("Verification code sent to {masked_email}"),
	codeSentToRecoveryEmail: gettext("Code sent to {masked_email}"),
	enterCodeFromEmail: gettext("Enter the 6-digit code sent to your recovery email"),
	verifyCode: gettext("Verify code"),
	useDifferentRecoveryEmail: gettext("Use a different recovery email"),

	// Recovery Email Success
	pleaseWait: gettext("Please wait..."),
	accountSuccessfullyVerified: gettext("Account successfully verified!"),

	// These strings are used when a user loses their MFA device and needs to recover via email
	noAccessToDevice: gettext("Cannot access your device?"),
	recoverDevice: gettext("Try another method"),
	doNotHaveAccessToDevice: gettext("Do not have access to your current device?"),
	recoverAccount: gettext("Recover Account"),
	enterOneTimeCode: gettext("Enter one-time code to continue"),
	recoveryEmailChallengeDescription: gettext(
		"If you don't have access to your current device, enter the one-time verification code sent to your recovery email address"
	),

	// Recovery Email Errors
	recovery_email_required: gettext("Recovery email is required to complete MFA setup"),
	cannot_use_primary_email: gettext(
		"You cannot use your account email as your recovery email. Please enter a different email address."
	),
	recovery_email_already_set: gettext(
		"This email is already set as your recovery email. Please enter a different email address."
	),

	recoveryEmailVerified: gettext("Recovery email verified"),
	recoveryEmailSetupComplete: gettext("Your recovery email has been set up successfully."),
	recoveryEmailUpdated: gettext("Recovery email updated"),

	// Recovery Email Errors
	invalidRecoveryEmail: gettext("Please enter a valid email address."),
	invalidVerificationCode: gettext("Invalid verification code. Please try again."),
	verificationCodeExpired: gettext("Verification code expired. Please request a new code."),
	recoveryEmailRequired: gettext("Recovery email is required."),
	codeRequired: gettext("Verification code is required."),

	// Cooldown / Rate Limiting
	cooldownActive: gettext("Please wait before requesting a new code."),
	resendCodeIn: gettext("Resend code in {seconds}s"),
	canResendNow: gettext("You can request a new code now."),

	// Recovery Email Challenge (Login Fallback)
	cantAccessDevice: gettext("Can't access your device?"),
	useRecoveryEmail: gettext("Use recovery email"),
	useRecoveryEmailDescription: gettext("We'll send a verification code to your recovery email."),
	sendCodeToRecoveryEmail: gettext("Send code to recovery email"),
	noRecoveryEmailSetup: gettext("No recovery email is set up for this account."),
	contactSupportForHelp: gettext("Please contact support for help accessing your account."),
	verifyingWithRecoveryEmail: gettext("Verifying with recovery email"),
	recoveryEmailChallengeSent: gettext(
		"A verification code has been sent to your recovery email."
	),

	// Recovery Email in Account Settings
	currentRecoveryEmail: gettext("Current recovery email"),
	changeRecoveryEmail: gettext("Change recovery email"),
	noRecoveryEmailConfigured: gettext("No recovery email configured"),
	addRecoveryEmailRecommended: gettext(
		"Adding a recovery email is recommended to help recover your account."
	),

	fieldErrors: {
		email: gettext("Please enter a valid email address"),
		text: gettext("Field is required"),
		currentPassword: gettext("Please enter your current password"),
		newPassword: gettext(
			"Passwords must be at least 8 characters long, contain at least one number and special character, and have both upper and lower case letters"
		),
		invalidFirstName: gettext("Invalid first name"),
		invalidLastName: gettext("Invalid last name"),
		invalidEmail: gettext("Invalid email"),
		invalidPassword: gettext("A stronger password is required"),
		invalidOrganizationName: gettext("Organization name is required"),
		invalidCaptcha: gettext("Invalid captcha, please try again"),
		invalidTaxNumber: gettext("Tax number is required"),
	},
	becomingApplicantMessage: gettext(
		"To finish setting up your applicant account, complete any required fields below and click Save."
	),
	navigateAwayWarning: gettext(
		"If you navigate away from this page without clicking save, your changes will be lost."
	),
	loginPage: { loginWithGoogle: gettext("Login with Google") },
	registrationPage: {
		returnTo: gettext("Return to"),
		registrationPageTitle: gettext("Register for an applicant account"),
		alreadyHaveAccount: gettext("Already have a SurveyMonkey Apply account?"),
		individualTabTitle: gettext("Register as an individual"),
		organizationTabTitle: gettext("Register as an organization"),
		firstName: gettext("First Name"),
		lastName: gettext("Last Name"),
		email: gettext("Email"),
		termsAndPolicy: gettext("By registering for an account, you agree to our"),
		termsOfService: gettext("terms of service"),
		privacyPolicy: gettext("privacy policy"),
		and: gettext("and"),
		createAccount: gettext("Create Account"),
		registerWithGoogle: gettext("Register with Google"),
		orgName: gettext("Organization name"),
		taxNumber: gettext("Tax number"),
		invalidCaptcha: gettext("Invalid captcha code"),
		password: gettext("Create a password"),
	},
	labels: { mfaSwitch: gettext("Multi-Factor Authentication Toggle") },
	accountSettingsPage: {
		title: gettext("My Account"),
		modals: {
			disconnectAccountModal: {
				areYouSureTitle: gettext("Are you sure?"),
				upperText: gettext(
					"Disconnecting your Google account from your SurveyMonkey Apply account means you will no longer use Google to sign into Apply. This cannot be undone."
				),
				lowerText: gettext(
					"To continue, please provide a password in the field below and click Disconnect."
				),
			},
			BecomeApplicantModal: {
				title: gettext("Become An Applicant"),
				bodyCfsRequired: gettext(
					"Some fields are required to complete your request. Please complete the fields below to continue."
				),
				requiredFields: gettext("Required Fields"),
			},
		},
		myProfileTab: {
			title: gettext("My Profile"),
			profileImage: gettext("Profile Image"),
			personalInfo: gettext("Personal Info"),
			managedBySSO: gettext("Managed by Single Sign On"),
			ssoNameTooltip: gettext(
				"Your first and last name are managed by Single sign-on and cannot be changed here. Please contact the sites administrator to request a change."
			),
			ssoEmailTooltip: gettext(
				"Your email address is managed by Single sign-on and cannot be changed here. Please contact the sites administrator to request a change."
			),
			ssoPasswordTooltip: gettext("Your password will not be bla bla."),
			ssoOnlyPasswordTooltip: gettext("Your password SSO ONLY."),
			linkedAccounts: gettext("Linked Accounts"),
			socialSignOn: gettext("Social Sign-on"),
			disconnectAccount: gettext("Disconnect account"),
			generalPreferences: gettext("General Preferences"),
			mfaEnabled: gettext("Multi-factor authentication (MFA)"),
			mfaLearnMoreLink: gettext("Learn more"),
			mfaLearnMoreText: gettext(
				"Get added security by confirming your identity via mobile device at login."
			),
			changeEnrolledDevice: gettext("Change enrolled device"),
			generateNewCodes: gettext("Generate new recovery codes"),
			emailChangeRequested: gettext(
				"You have requested to change your account email address to"
			),
			emailChangeCheckEmail: gettext(
				"Please check your new email address for a confirmation email to complete the change."
			),
		},
		userSectionTab: {
			title: gettext("Site Settings"),
			registration: gettext("Registration"),
			notApplicantTitle: gettext("You are not registered on this site as an applicant."),
			becomeApplicant: gettext("Become an applicant"),
			setupOrganizationTitle: gettext("Set up an organization to apply on behalf of."),
			setupOrganization: gettext("Set up organization"),
			customFieldsLabel: gettext("Extras"),
			organizations: gettext("Your Organizations"),
			organizationName: gettext("Organization Name"),
			organizationRole: gettext("Role"),
			primary_admin: gettext("Primary Organization Manager"),
			admin: gettext("Manager"),
			member: gettext("Member"),
		},
		notificationSettingsTab: {
			title: gettext("Notification Settings"),
			cardTitle: gettext("Notifications from this site"),
			notify_direct_messages: gettext("Direct messages from the site administrator"),
			request_review: gettext("Request to review applications"),
			notify_recommender_updates: gettext("Updates on my recommendations"),
			email_subscribed: gettext("Unsubscribe from all emails from this site"),
			notify_applicant_activity: gettext("Updates on activity regarding my applications"),
			notify_applicant_invitation: gettext(
				"Invitation requests to collaborate on an application"
			),
			notify_applicant_reminders: gettext("Deadline reminders for applications"),
			notify_reviewer_assigned: gettext("Emails when I've been assigned a review"),
			notify_reviewer_reminders: gettext("Deadline reminders for reviews"),
			notify_recommender_reminders: gettext("Deadline reminders for recommendations"),
			notify_recommender_requests: gettext(
				"Invitation requests to act as a recommender on an application"
			),
		},
		userEligibilityTab: {
			title: gettext("Eligibility"),
			eligibilityProfile: gettext("Eligibility Profile"),
			completeEligibilityProfileBtn: gettext("Complete eligibility profile"),
			fillOutEligibilityBtn: gettext("Fill out eligibility profile"),
			eligibilityNotStarted: gettext("Eligibility has not been started"),
		},
		needHelp: gettext("NEED HELP?"),
		CustomerSupportText: gettext("24/7 email customer support"),
		visitHelpCenter: gettext("Visit our Help Center"),
	},
	passwordField: {
		charactersLong: gettext("Password must contain at least 8 characters"),
		charactersUpper: gettext("Password must contain at least 1 uppercase character"),
		charactersSpecial: gettext("Password must contain at least 1 special character"),
		charactersNumbers: gettext("Password must contain at least 1 number"),
		passwordLabel: gettext("Password"),
		confirmPassword: gettext("Confirm password"),
	},
	toast: {
		success: gettext("Success"),
		error: gettext("Error"),
		accountDisconnected: gettext("Account disconnected"),
		customFieldErrors: gettext(
			"One or more errors occurred while saving custom fields, your account has not been updated"
		),
		accountUpdated: gettext("Account has been updated"),
		accountNotUpdated: gettext(
			"One or more errors occurred, your account has not been updated"
		),
		accountSettingsReset: gettext("Account settings have been reset"),
		emailChangeRequestResent: gettext("Request to change email address has been resent"),
		unknownError: gettext("An unknown error has occurred, please contact technical support"),
		invalidPassword: gettext("The password you have entered is invalid, please try again"),
	},
};

export default STRINGS;
